var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sdz-modal",
    {
      ref: "sdzModal",
      attrs: {
        title: _vm.modalTitle,
        "confirm-button-label": "Adicionar",
        "confirmation-event": "saveConfiguration",
        "cancel-event": "cancelConfiguration",
        width: "600",
        persistent: "",
        "custom-class": "default-sheet-modal",
        "buttons-position": "right",
        "close-icon": "",
      },
      on: {
        close: _vm.close,
        saveConfiguration: _vm.saveConfiguration,
        cancelConfiguration: _vm.cancelConfiguration,
      },
    },
    [
      [
        _c(
          "div",
          { staticClass: "content" },
          [
            _vm.loading
              ? _c("AppLoadingIcon", {
                  staticClass: "loading",
                  attrs: { color: "#BBB" },
                })
              : [
                  _c("div", [
                    _vm._v(
                      "\n          Ao adicionar os produtos, caso o vendedor atinja o valor mínimo do percentual obtido para todas as faixas, o valor do produto será multiplicado pelo fator correspondente à faixa "
                    ),
                    _c("b", [_vm._v(_vm._s(_vm.multiplierName))]),
                    _vm._v(".\n        "),
                  ]),
                  _vm._v(" "),
                  _c("AppSelectGroup", {
                    attrs: {
                      items: _vm.campaignHighlightProducts,
                      label: "Produtos em destaque",
                      "on-text": "productName",
                      "on-value": "productId",
                      placeholder: "Selecione os produtos",
                      clearable: "",
                      multiple: "",
                    },
                    model: {
                      value: _vm.form,
                      callback: function ($$v) {
                        _vm.form = $$v
                      },
                      expression: "form",
                    },
                  }),
                ],
          ],
          2
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }